

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl, EBaseUrl } from "../../../Helper/BaseUrl";
import { toastError, toastErrorr } from "../../../Helper/ToastMessage";


// Get Table Data
export const UploadedComplaintTableDataAPI = createAsyncThunk("UploadedComplaintTableData", async ({ data }) => {
    const {
        M_FinacialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        M_WardID,
        T_ComplaintDetailsID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${EBaseUrl}/Dashboard/Get_WEB_T_Encroach_ComplaintDetails_Select?M_FinacialYearID=${M_FinacialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&T_ComplaintDetailsID=${T_ComplaintDetailsID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastErrorr('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const UploadedComplaintTableDataSlice = createSlice({
    name: "UploadedComplaintTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UploadedComplaintTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(UploadedComplaintTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(UploadedComplaintTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const UploadedComplaintTableDataReducer = UploadedComplaintTableDataSlice.reducer

// Get Table Data
export const ComplaintTrackGetTableDataAPI = createAsyncThunk("ComplaintTrackGetTableData", async ({ data }) => {
    const {
        T_ComplaintDetailsID,   
        Language,
        M_UserID,
        Top,
        token,
        setCompleteTrackData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Dashboard/Get_T_Encroach_ComplaintDetails_Track_Select?T_ComplaintDetailsID=${T_ComplaintDetailsID}&Language=${Language}&M_UserID=${M_UserID}&Top=${Top}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    setCompleteTrackData(result.data.table)
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const ComplaintTrackGetTableDataSlice = createSlice({
    name: "ComplaintTrackGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ComplaintTrackGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ComplaintTrackGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ComplaintTrackGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const ComplaintTrackGetTableDataReducer = ComplaintTrackGetTableDataSlice.reducer



